import ApplicationAdapter from 'eflex/adapters/application';

export default class PlcHardwareAdapter extends ApplicationAdapter {
  pathForType() {
    return 'hardwares';
  }
}
